import { logoutAction } from 'actions/login-actions';
import { getToken, logout as logoutHelper } from 'grab-login/lib/helper';

export const logOut = () => {
  logoutHelper();
  logoutAction({ token: getToken() });
  window.location.reload();
};

export default {};
